// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"itemsGalleryStyle_mainContainer__1rAG8","itemList":"itemsGalleryStyle_itemList__1Gjjm"};